import React, { useEffect, useState, useRef } from "react";
import "../styles/TeamModal.css";
import { gsap } from "gsap";
import { Flip } from "gsap/Flip";
import CountUp from "./CountUp";

gsap.registerPlugin(Flip);


type TeamMember = {
    id: string;
    name: string;
    role: string;
    department: string;
    subject?: string;
    image: string;
    isCommite?: boolean;
};

type TeamModalProps = {
    isOpen: boolean;
    onClose: () => void;
};

const teamMembers: TeamMember[] = [
    // ===== Commite =====

    {
        id: "president",
        name: "Ethan de Sá",
        role: "Team President",
        department: "Leadership",
        subject: "Electrical Engineering",
        image: "/images/team/Ethan.jpg",
        isCommite: true,
    },
    // for future Vice President
    // {
    //     id: "vice-president",
    //     name: "Catlin Barry",
    //     role: "Vice President",
    //     department: "Chassis",
    //     subject: "Mechanical Engineering",
    //     image: "/images/team/Catlin.png",
    //     isCommite: true,
    // },
     {
        id: "treasurer" ,
        name: "Hunter Pennman",
        role: "Team Treasurer",
        department: "Electrical",
        subject: "Who gives a shit",
        image: "/images/team/HunterReal.jpge",
        isCommite: true,
    },
    {
        id: "vice-president",
        name: "Coryn Walsh",
        role: "Communications Officer",
        department: "Buisness",
        subject: "Digital Marketing",
        image: "/images/team/Coryn.jpg",
        isCommite: true,
    },

    // ===== Team Leads =====

    {
        id: "int-1",
        name: "Findlay",
        role: "Head of Integration",
        department: "Integration",
        subject: "Top Secret",
        image: "/images/team/Findlay.jpg",
    },
    {
        id: "susp-1",
        name: "Angus",
        role: "Head of Suspension and Front End",
        department: "Suspension and Front End",
        subject: "Top Secret",
        image: "/images/team/Angus.jpg",
    },
    {
        id: "chas-1",
        name: "Catlin Barry",
        role: "Head of Chassis",
        department: "Chassis",
        subject: "Mechanical Engineering",
        image: "/images/team/Catlin.jpg",
    },
    {
        id: "elec-1",
        name: "Hunter Pennman",
        role: "Head of Electrical",
        department: "Electrical",
        subject: "Who gives a",
        image: "/images/team/HunterReal.jpg",
    },
    {
        id: "powe-1",
        name: "Kiaren",
        role: "Head of Powertrain",
        department: "Powertrain",
        subject: "Top Secret",
        image: "/images/team/Kiaren.jpg",
    },
    {
        id: "soft-1",
        name: "Alana",
        role: "Head of Special Projects",
        department: "Special Projects",
        subject: "Computing and Creative Design",
        image: "/images/team/Alana.jpg",
    },
    {
        id: "boar-1",
        name: "Vlad",
        role: "Head of BOAR Project",
        department: "BOAR",
        subject: "Top Secret",
        image: "/images/team/Vlad.jpg",
    },
    {
        id: "busi-1",
        name: "Coryn Walsh",
        role: "Head of Business and Communications",
        department: "Business",
        subject: "Digital Marketing",
        image: "/images/team/Coryn.jpg",
    },
    {
        id: "lpts-1",
        name: "Wojciech Masiak",
        role: "Head of Lap Time Simulation",
        department: "LTS",
        subject: "Mechanical Engineering",
        image: "/images/team/Woj.jpg",
    },


    // ===== ELECTRICAL =====

    {
        id: "elec-2",
        name: "Chris",
        role: "Electrical Engineer",
        department: "Electrical",
        subject: "Electrical Engineering",
        image: "/images/team/placeHolder.png",
    },
    {
        id: "elec-3",
        name: "Euan",
        role: "Electrical Engineer",
        department: "Electrical",
        subject: "Electrical Engineering",
        image: "/images/team/placeHolder.png",
    },
    {
        id: "elec-4",
        name: "Josh",
        role: "Electrical Engineer",
        department: "Electrical",
        subject: "Electrical Engineering",
        image: "/images/team/placeHolder.png",
    },

    // ===== SUSPENSION AND FRONT END =====
    {
        id: "susp-2",
        name: "Eduard",
        role: "Suspension and Front End Engineer",
        department: "Suspension and Front End",
        subject: "architectural Technologies",
        image: "/images/team/placeHolder.png",
    },
    {
        id: "susp-3",
        name: "Andreas",
        role: "Suspension and Front End Engineer",
        department: "Suspension and Front End",
        subject: "Top Secret",
        image: "/images/team/placeHolder.png",
    },
    {
        id: "susp-4",
        name: "Hamza",
        role: "Suspension and Front End Engineer",
        department: "Suspension and Front End",
        subject: "Top Secret",
        image: "/images/team/placeHolder.png",
    },
    {
        id: "susp-5",
        name: "Prince",
        role: "Suspension and Front End Engineer",
        department: "Suspension and Front End",
        subject: "Top Secret",
        image: "/images/team/placeHolder.png",
    },
    {
        id: "susp-6",
        name: "Zaid",
        role: "Suspension and Front End Engineer",
        department: "Suspension and Front End",
        subject: "Top Secret",
        image: "/images/team/placeHolder.png",
    },
    {
        id: "susp-7",
        name: "Kattie",
        role: "Brakes Engineer",
        department: "Suspension and Front End",
        subject: "Mechanical & Engineering",
        image: "/images/team/placeHolder.png",
    },
    {
        id: "susp-8",
        name: "Kirsty",
        role: "Uprights Engineer",
        department: "Suspension and Front End",
        subject: "Top Secret",
        image: "/images/team/placeHolder.png",
    },
    {
        id: "susp-9",
        name: "Ruby",
        role: "Uprights Engineer",
        department: "Suspension and Front End",
        subject: "Top Secret",
        image: "/images/team/placeHolder.png",
    },
    {
        id: "susp-10",
        name: "Jemma",
        role: "Steering Engineer",
        department: "Suspension and Front End",
        subject: "Art and Design",
        image: "/images/team/placeHolder.png",
    },

    // ===== POWERTRAIN =====
    {
        id: "powe-2",
        name: "Nico",
        role: "Powertrain Engineer",
        department: "Powertrain",
        subject: "Top Secret",
        image: "/images/team/placeHolder.png",
    },

    // ===== Integration =====
    {
        id: "int-2",
        name: "Aimee",
        role: "Integration",
        department: "Integration",
        subject: "Architecture",
        image: "/images/team/placeHolder.png",
    },

    // ===== CHASSIS =====

    {
        id: "chas-2",
        name: "Oliver",
        role: "Chassis Engineer",
        department: "Chassis",
        subject: "Top Secret",
        image: "/images/team/placeHolder.png",
    },
    {
        id: "chas-3",
        name: "D'Angello",
        role: "Chassis Engineer",
        department: "Chassis",
        subject: "Top Secret",
        image: "/images/team/placeHolder.png",
    },

    // ===== SPECIAL PROJECTS =====
    {
        id: "soft-2",
        name: "Jack Smart",
        role: "Web Developer and Special Projects Engineer",
        department: "Special Projects",
        subject: "Computing Science",
        image: "/images/team/placeHolder.png",
    },

    // ===== BOAR =====
    {
        id: "boar-2",
        name: "Archie",
        role: "BOAR Engineer",
        department: "BOAR",
        subject: "Computer Science",
        image: "/images/team/placeHolder.png",
    },
    {
        id: "boar-3",
        name: "Bruce",
        role: "BOAR Engineer",
        department: "BOAR",
        subject: "Computer Science",
        image: "/images/team/placeHolder.png",
    },

    // ===== BUSINESS =====
    {
        id: "busi-2",
        name: "Ellie",
        role: "Business and Communications",
        department: "Business",
        subject: "Top Secret",
        image: "/images/team/Ellie.jpg",
    },
    {
        id: "busi-3",
        name: "Anas",
        role: "Business and Communications",
        department: "Business",
        subject: "Top Secret",
        image: "/images/team/Anas.jpg",
    },
    {
        id: "busi-4",
        name: "Ailsa",
        role: "Business and Communications",
        department: "Business",
        subject: "Top Secret",
        image: "/images/team/Ailsa.jpg",
    },
    {
        id: "busi-5",
        name: "Sian",
        role: "Business and Communications",
        department: "Business",
        subject: "Top Secret",
        image: "/images/team/Sian.jpg",
    }


];

const TeamModal: React.FC<TeamModalProps> = ({ isOpen, onClose }) => {
    const [selectedDept, setSelectedDept] = useState<string>("All");

    const modalRef = useRef<HTMLDivElement>(null);
    const membersGridRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleEsc = (e: KeyboardEvent) => {
            if (e.key === "Escape") onClose();
        };

        if (isOpen) {
            document.addEventListener("keydown", handleEsc);
            document.body.style.overflow = "hidden";

            // 🔥 MODAL ENTRANCE ANIMATION
            if (modalRef.current) {
                gsap.fromTo(
                    modalRef.current,
                    { opacity: 0, scale: 0.95, y: 30 },
                    {
                        opacity: 1,
                        scale: 1,
                        y: 0,
                        duration: 0.6,
                        ease: "power3.out",
                    }
                );
            }
        }

        return () => {
            document.removeEventListener("keydown", handleEsc);
            document.body.style.overflow = "auto";
        };
    }, [isOpen, onClose]);

    // 🔥 FILTER ANIMATION
    useEffect(() => {
        if (!membersGridRef.current) return;

        const cards = membersGridRef.current.querySelectorAll(".team-card");

        gsap.fromTo(
            cards,
            { opacity: 0, y: 20 },
            {
                opacity: 1,
                y: 0,
                duration: 0.5,
                stagger: 0.25,
                ease: "power2.out",
            }
        );
    }, [selectedDept]);

    if (!isOpen) return null;

    const leads = teamMembers.filter((m) => m.isCommite);
    const members = teamMembers.filter((m) => !m.isCommite);

    const departments = [
        "All",
        ...Array.from(new Set(members.map((m) => m.department))),
    ];

    const filteredMembers =
        selectedDept === "All"
            ? members
            : members.filter((m) => m.department === selectedDept);

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div
                className="modal-content"
                ref={modalRef}
                onClick={(e) => e.stopPropagation()}
            >
                <button className="close-btn" onClick={onClose}>
                    ✕
                </button>

                {/* HEADER */}
                <div className="team-header">
                    <h2>The Team</h2>
                    <span className="season-badge">2026 Season Team</span>
                </div>

                {/* ===== LEADS ===== */}
                <section className="team-section">

                    <div>


                        <div className="grid grid-cols-3 grid-rows-3 gap-4 text-6xl font-bold mb-8 text-white">
                            <div className="row-span-3 p-4">
                                <CountUp
                                    from={0}
                                    to={60}
                                    separator=","
                                    direction="up"
                                    duration={1}
                                    className="count-up-text "

                                /><br/>
                                <p>Members</p>

                            </div>
                            <div className="row-span-3 p-4">
                                <CountUp
                                    from={0}
                                    to={9}
                                    separator=","
                                    direction="up"
                                    duration={1}
                                    delay={0.5}
                                    className="count-up-text"

                                />
                                <p>Departments</p>
                            </div>
                            <div className="row-span-3 p-4">
                                <CountUp
                                    from={0}
                                    to={1}
                                    separator=","
                                    direction="up"
                                    duration={1}
                                    delay={1}
                                    className="count-up-text"

                                />
                                <p>Team</p>

                            </div>
                        </div>


                    </div>

                    <h3 className="section-title">Lecturer</h3>
                    <div className="team-grid leads-grid">

                            <div className="team-card lead-card">
                                <div className="image-wrapper">
                                    <img src="/images/team/Scott.jpeg" alt="Scott Muirson" />
                                </div>
                                <h3>Scott Muirson</h3>
                                <p>Engineering Applications Supervisor</p>
                            </div>

                    </div>
                </section>

                {/* ===== LEADS ===== */}
                <section className="team-section">
                    <h3 className="section-title">Team Committee</h3>
                    <div className="team-grid leads-grid">
                        {leads.map((member) => (
                            <div className="team-card lead-card" key={member.id}>
                                <div className="image-wrapper">
                                    <img src={member.image} alt={member.name} />
                                </div>
                                <h3>{member.name}</h3>
                                <p>{member.role}</p>
                            </div>
                        ))}
                    </div>
                </section>

                {/* ===== FILTER TABS ===== */}
                <section className="team-section">
                    <h3 className="section-title">Departments</h3>

                    <div className="department-tabs">
                        {departments.map((dept) => (
                            <button
                                key={dept}
                                className={`dept-btn ${
                                    selectedDept === dept ? "active" : ""
                                }`}
                                onClick={() => setSelectedDept(dept)}
                            >
                                {dept}
                            </button>
                        ))}
                    </div>

                    {/* MEMBERS GRID */}
                    <div
                        className="team-grid members-grid"
                        ref={membersGridRef}
                    >
                        {filteredMembers.map((member) => (
                            <div className="lead-card team-card" key={member.id}>
                                <div className="image-wrapper">
                                    <img src={member.image} alt={member.name} />
                                </div>
                                <h3>{member.name}</h3>
                                <p>{member.role}</p>
                                {/*<p>Studying: {member.subject}</p>*/}
                            </div>
                        ))}
                    </div>
                </section>
            </div>
        </div>
    );
};

export default TeamModal;
